define('utils/overlay',['jquery'], function ($) {
	
	/**
	 * Overlay wrapper
	 * 
	 * options
	 * element: $(.overlay)
	 * headerCount: boolean, if the headercount is visible
	 * onNext: function 
	 * onPrev: function
	 * stacking: boolean, multiple stacks available?
	 */

	var Overlay = function (options) {
		// voor inner scope
		var $this = this;
		
		// options
		this.options = $.extend({
			element : $('.overlay').first(),
			previous: null,
			headerCount : false,
			keepAfterHide: true,
			//Submits en links in overlay weergeven
			navigation: false,
			callback: function () {},
			//Na het aanroepen van content(html)
			onLoad : function (element) {},
			//Als navigatie aanstaat en json binnenkomt
			onData : function (data, overlay) {
				$this.options.onLoad(data.html);
			},
			onClose : function () {},
			onOpen : function () {}
		}, options);
		
		this.options.element = this.options.element.clone().insertAfter(this.options.previous != null ? this.options.previous.options.element : this.options.element);

		// header Count disable
		if(!this.options.headerCount) {
			this.options.element.find('.nr').css('display', 'none');
		}
		
		// close button
		this.options.element.find('.close').click(function (e) {
			e.preventDefault();
			$this.hide();
		});
		
		// area around overlay-content
		this.options.element.click(function (e) {
			if($(e.target).is('.overlay') && $this.isVisible()) {
				$this.hide();
			}
		});
		
		$(document).keyup(function (event) {
			if(event.keyCode == 27 && $this.isVisible()) { // ESC
				event.preventDefault();
				$this.hide();
			}
		});
		
		this.getElement = function () {
			return this.options.element.find('.overlay-content');
		};
		
		// show the overlay
		this.show = function () {
			this.options.onOpen.call(this);
			
			this.options.element.css('display', 'block');
			this.options.element.css('opacity', '1');

			if (this.options.previous!=null)
				this.options.previous.stack(true, this.options.element.find('.overlay-main').height());
			else
				$('body').addClass('noscroll');
		};

		// hide the overlay
		this.hide = function () {
			this.options.element.css('display', 'none');
			this.options.onClose.call(this);

			if (this.options.previous!=null)
				this.options.previous.stack(false, this.options.element.find('.overlay-main').height());
			else
				$('body').removeClass('noscroll');
		
			if (!this.options.keepAfterHide)
				this.close();
		};
		
		// verwijder overlay
		this.close = function() {
			this.options.element.remove();
		};

		// stack overlay
		this.stack = function ($show, $height) {
			var $info = this.options.element.find('.overlay-main');
			if ($show) {
				this.options.element.css('background', 'none');
				$info.css('margin-top', 60+$height+50);
			} else {
				this.options.element.css('background', '');
				$info.css('margin-top', 60);
			}
		};

		// set content of the overlay
		this.content = function (html) {
			this.getElement().html(html);
			
			this.options.onLoad(this.options.element);

			//Zorg ervoor dat links en submits in overlay openen
			if (this.options.navigation) {
				this.options.element.find('a').not('.close, .noajax').click(function(){
					$.get($(this).attr('href'), function(data){
						$this.options.onData(data, $this);
					});
					return false;
				});

				this.options.element.find('form').submit(function(){
					//HACK: gebruik van this ipv $(this)
					$.post(this.action, $(this).serializeArray(), function(data){
						if (data.status==0) {
							$this.hide();
							$this.options.callback();
						} else
							$this.options.onData(data, $this);
					});
					return false;
				});
			}
		};
		
		// is the overlay currently visible?
		this.isVisible = function () {
			return this.options.element.css('display') == 'block';
		};
		
		// set title of overlay
		this.title = function (title, i, max) {
			var context = this.options.element.find('header');
			context.find('h1').text(title);
			
			if(this.options.headerCount)
				context.find('h1').append('<span>' + i + ' van ' + max+ '</span>');	
		};
	};
	
	return Overlay;
	
});
